import { Component, CUSTOM_ELEMENTS_SCHEMA, OnInit, OnDestroy } from '@angular/core';

import { Subscription } from 'rxjs';
import { MfeLoaderService } from 'src/app/shared/services/mfe-loader.service';

@Component({
  selector: 'settings-mfe',
  template: `
    <div class="mfe-container">
      @if (error) {
        <div class="error-state">
          <p>An error occurred. If the issue persists, please contact support.</p>
          <button (click)="retryLoad()" class="retry-btn">Retry</button>
        </div>
      }
      @if (isReady && !error) {
        <pipa-mfe
          [attr.feature]="'settings'"
        ></pipa-mfe>
      }
    </div>
    `,
  styles: [
    `
      .mfe-container {
        width: 100%;
        height: 100%;
        overflow: visible;
      }
      .error-state {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
        gap: 16px;
        padding: 24px;
      }
      .retry-btn {
        padding: 8px 16px;
        border-radius: 4px;
        border: 1px solid #ccc;
        background: #0A2540;
        cursor: pointer;
      }
      .retry-btn:hover {
        background: #f5f5f5;
      }
    `,
  ],
  imports: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SettingsMFEComponent implements OnInit, OnDestroy {
  isReady = false;
  error: string | null = null;

  private subscription?: Subscription;

  constructor(private mfeLoader: MfeLoaderService) { }

  ngOnInit() {
    this.subscription = this.mfeLoader.state$.subscribe(state => {
      this.isReady = state.isLoaded;
      this.error = state.error;
    });
  }

  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  retryLoad() {
    this.mfeLoader.retry();
  }
}
